import {z} from 'zod'

import {CreateOrUpdateBlockKpiDocument} from '@sdox/api'

import {KpiRowForm} from '../../SharedForms/Kpi/KpiRowForm'
import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {kpiFormSchema} from '../../utils/schemas'
import {createFormConfig} from '../../utils/createFormConfig'
import {kpiFormValueToKpiInput} from '../../utils/kpiFormValueToKpiInput'

import type {BlockKpiInput, CreateOrUpdateBlockKpiMutation} from '@sdox/api'

type CreateKpisValidatorSchema = z.infer<typeof createKpisValidatorSchema>

const createKpisValidatorSchema = z.object({
  data: z.array(kpiFormSchema),
  meta: createMetaSchema,
})

export const kpiConfig = createFormConfig<
  CreateKpisValidatorSchema,
  CreateOrUpdateBlockKpiMutation,
  BlockKpiInput[]
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockKpiDocument,
  },
  validatorSchema: createKpisValidatorSchema,
  fieldMapper: (fieldValues) => {
    if (!Array.isArray(fieldValues.data)) {
      throw new Error('input must have a data array')
    }

    return fieldValues.data.map(kpiFormValueToKpiInput)
  },
  customFormNode: <KpiRowForm />,
})
